import { WORKSPACE_ROUTES } from "@/lib/workspace-routes";

export function isSimulatorEditorPath(pathname: string) {
  return pathname.startsWith(WORKSPACE_ROUTES.workbenchBuild);
}

export function buildSimulatorEditorHref({
  build,
  kind,
  template,
  ticker,
}: {
  build?: string;
  kind?: string | null;
  template?: string | null;
  ticker?: string | null;
} = {}) {
  const params = new URLSearchParams();
  if (build) params.set("build", build);
  if (kind) params.set("kind", kind);
  if (template) params.set("template", template);
  if (ticker) params.set("ticker", ticker);
  const query = params.toString();
  return query
    ? `${WORKSPACE_ROUTES.workbenchBuild}?${query}`
    : WORKSPACE_ROUTES.workbenchBuild;
}

export function buildTickerWorkspaceSimulatorHref(workspaceId: string) {
  const params = new URLSearchParams({ workspace: workspaceId });
  return `${WORKSPACE_ROUTES.workbenchBuild}?${params.toString()}`;
}
